module.exports = __webpack_public_path__ + "img/full2-min.aef34c55.png";